import { render, staticRenderFns } from "./DuckMeasurementDetails.vue?vue&type=template&id=7a772fa1&scoped=true"
import script from "./DuckMeasurementDetails.vue?vue&type=script&lang=js"
export * from "./DuckMeasurementDetails.vue?vue&type=script&lang=js"
import style1 from "./DuckMeasurementDetails.vue?vue&type=style&index=1&id=7a772fa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a772fa1",
  null
  
)

export default component.exports